import type { Components, Theme } from "@mui/material";

export const cardContentTheme: Components<Theme>["MuiCardContent"] = {
  styleOverrides: {
    root: () => ({
      padding: 0,
      margin: "24px",
    }),
  },
};
